import React from 'react';

import { MenuOpenOutlined } from '@mui/icons-material';
import { type SxProps } from '@mui/material';

type Props = {
  sx?: SxProps;
  fontSize?: Parameters<typeof MenuOpenOutlined>[0]['fontSize'];
};

export default function NavigationTreeOutlined({ sx, ...props }: Props) {
  return <MenuOpenOutlined {...props} sx={{ ...sx, rotate: '180deg' }} />;
}
